"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGenericTrackingData = void 0;
const bowser_1 = require("bowser");
const cookies_1 = require("./cookies");
const oneTrustCookieHelper_1 = require("./oneTrustCookieHelper");
const init_1 = require("../init");
const getGenericTrackingData = (userAgent, consent) => {
    var _a, _b, _c, _d;
    userAgent = userAgent || window.navigator.userAgent;
    consent =
        consent ||
            (0, oneTrustCookieHelper_1.getConsentFromOneTrustCookie)() ||
            window.OnetrustActiveGroups ||
            ',,';
    const bowser = (0, bowser_1.getParser)(userAgent);
    const placementIdCookie = (0, cookies_1.getCookie)('placementId');
    const queryParamsString = window.location.search;
    const queryParams = new URLSearchParams(queryParamsString);
    const trackingParams = [
        'fbclid',
        'gclid',
        'data1',
        'data2',
        'amount',
        'initialPayment',
        'placementId',
        'subaffiliateid',
        'ref',
        'utm_campaign',
        'utm_term',
        'utm_content',
        'utm_medium',
        'utm_source',
        'matchtype',
        'mkt_ab_test',
        'mkt_topic',
        'send_date',
        'msclkid',
        'obclickid',
        'plcid',
        'aid',
        'tbclid',
        'yclid',
        'leadIdHash',
        'traversalId',
        'ttclid',
        'sub4',
        'adupclid',
        'twgclid',
        'nat_clid',
    ];
    const genericTrackingData = {
        deviceCategory: bowser.getPlatformType(),
        browser: bowser.getBrowserName(),
        browserVersion: bowser.getBrowserVersion(),
        operatingSystem: bowser.getOSName(),
        operatingSystemVersion: bowser.getOSVersion(),
        consentLevel: consent,
        fcId: (0, cookies_1.getSessionId)(),
        fbpCookie: (0, cookies_1.getCookie)('_fbp'),
        fbcCookie: (0, cookies_1.getCookie)('_fbc'),
        redirectedFrom: (0, cookies_1.getRedirectedFrom)(),
        segmentWriteKey: init_1.segmentWriteKeyForTracking,
        purpose: (_b = (_a = queryParams.get('purpose')) !== null && _a !== void 0 ? _a : queryParams.get('category')) !== null && _b !== void 0 ? _b : undefined,
        term: (_d = (_c = queryParams.get('term')) !== null && _c !== void 0 ? _c : queryParams.get('duration')) !== null && _d !== void 0 ? _d : undefined,
    };
    if (placementIdCookie) {
        genericTrackingData.placementIdCookie = placementIdCookie;
    }
    trackingParams.forEach((trackingParam) => {
        var _a;
        genericTrackingData[trackingParam] =
            (_a = queryParams.get(trackingParam)) !== null && _a !== void 0 ? _a : undefined;
    });
    return genericTrackingData;
};
exports.getGenericTrackingData = getGenericTrackingData;
//# sourceMappingURL=genericTrackingData.js.map